<template>
  <div class="AlertMessage">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AlertMessage'
}
</script>

<style lang="scss" scoped>
.AlertMessage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 95%;
}
</style>
